import NewSurvey from './NewSurvey';
export default NewSurvey;
